import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const ns = 'event-list-page';
export const useEventListPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = ({
  [ns]: {
    title: 'Архив событий обнаружение, совпадение',
  },
}) as Record<string, unknown>;

export const en = ({
  [ns]: {
    title: 'Event archive detection, matching',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [ns]: {
    title: 'Archivo de eventos detección, coincidencia',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [ns]: {
    title: 'Arquivo de eventos detecção, correspondência',
  },
}) as Record<string, unknown>;
